var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7313_7494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.489 5.83318L5.19732 14.1248C5.04552 14.282 4.96152 14.4925 4.96342 14.711C4.96532 14.9295 5.05296 15.1385 5.20747 15.293C5.36198 15.4475 5.57099 15.5352 5.78948 15.5371C6.00798 15.539 6.21848 15.455 6.37565 15.3032L14.6673 7.01152V11.6665C14.6673 11.8875 14.7551 12.0995 14.9114 12.2558C15.0677 12.4121 15.2796 12.4998 15.5007 12.4998C15.7217 12.4998 15.9336 12.4121 16.0899 12.2558C16.2462 12.0995 16.334 11.8875 16.334 11.6665V4.99985C16.334 4.77884 16.2462 4.56687 16.0899 4.41059C15.9336 4.25431 15.7217 4.16652 15.5007 4.16652H8.83398C8.61297 4.16652 8.40101 4.25431 8.24473 4.41059C8.08845 4.56687 8.00065 4.77884 8.00065 4.99985C8.00065 5.22086 8.08845 5.43283 8.24473 5.58911C8.40101 5.74539 8.61297 5.83318 8.83398 5.83318H13.489Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7313_7494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 -1 20.5 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpRight);
export default __webpack_public_path__ + "static/media/up-right.f277f7a9ee1b1128875f1fc24c64a6e7.svg";
export { ForwardRef as ReactComponent };